export const FETCH_SKILL_SUCCESS = 'FETCH_SKILL_SUCCESS';
